import React, {useRef} from 'react'


import ColorsSelector from '../../../../../../../../com/colorsSelector2/ColorsSelector'
import TextInput from '../../../../../../../../com/textInput/TextInput'

import LabelFileSelector from '../../../../../../../../com/labelFileSelector/LabelFileSelector';

import GuiThemesHeader, {IGuiThemesHeaderRef} from '../header/GuiThemesHeader'

import StatusPopup, {StatusPopupType} from '../../../../../../../../com/statusPopup/StatusPopup'

import DragManager from '../../../../../../../../com/dragManager/DragManager'

import {FileDto, GuiSettingsDto, IconStyleDto} from '../../../../../../../../dtos';

import './GuiThemeSettingsPopup.scss'

import {useEffect, useState} from 'react';
import {FONT_NAME_ROBOTO, FONTS_ARRAY_FOR_SELECT} from '../../../../../../../../globals';

import ImageLoader from '../../../../../../../../com/imageLoader/ImageLoader'
import {Box, Grid, Typography} from "@mui/material";
import {ReactComponent as UploadIcon} from "../../../../../../../../assets/editors/upload_icon.svg";
import {AsyncImageWithLoader} from "../../../../../../../../com/imageWithLoader/imageWithLoader";
import {ReactComponent as ImageWithError} from "../../../../../../../../assets/promos&items/image_error.svg";
import {getIconStyle} from "../../../../../../../../globals/globFunctions";
import {IconsStylesDropdown} from "../../../../../../../../com/iconsStyleSelector/iconsStylesDropdown";
import FontsSelect from "../../../../../../../../com/fontsSelect/fontsSelect";

// import {ReactComponent as ImageWithError} from "../../../../../../../../assets/promos&items/image_error.svg";

interface IGuiThemeSettingsPopup {
    show: boolean;
    onHide: () => void;
    dto: GuiSettingsDto;
    onSave: (dto: GuiSettingsDto, backgroundFile: FileDto | null, logoFile: FileDto | null) => void;
}


const GuiThemeSettingsPopup: React.FC<IGuiThemeSettingsPopup> = (props) => {
    const [themeName, setThemeName] = useState('')
    const [color, setColor] = useState('#ffff00')
    const [backgroundColor, setBackgroundColor] = useState<string | null>('#ffff00')

    const [logo, setLogo] = useState<FileDto | null>(null)
    const [backgroundImg, setBackgroundImg] = useState<FileDto | null>(null);
    const [logoUrl, setLogoUrl] = useState<string | null>(null);
    const [backgroundUrl, setBackgroundUrl] = useState<string | null>(null);

    const [isImageUrlSelected, setImageUrlMain] = useState<boolean>(false);

    const [fontName, setFontName] = useState(FONT_NAME_ROBOTO)
    const [fontLabel, setFontLabel] = useState(FONT_NAME_ROBOTO)

    const [infoPopupSubTitle, setInfoPopupSubTitle] = useState('');
    const [showInfoPopup, setShowInfoPopup] = useState(false);
    const [iconStyle, setIconStyle] = useState<IconStyleDto>(getIconStyle(props.dto.gusIconContrast || 1));

    const contentRef = useRef<HTMLDivElement>(null)
    const headerRef = useRef<IGuiThemesHeaderRef>(null)

    let dragManager = useRef<DragManager | null>(null)
    if (dragManager.current === null) {
        dragManager.current = new DragManager();
    }

    const onColorSwatchChange = (hexColor: string) => {
        setColor(hexColor);
    }

    const onBackgroundSwatchChange = (hexColor: string) => {
        setBackgroundColor(hexColor);
        setImageUrlMain(false);
    }

    const onFontSelectorChange = (value: string) => {
        // setFontName(font.value);
        // setFontLabel(font.label);
        setFontName(value);
        const selectedFont = FONTS_ARRAY_FOR_SELECT.find((fontInArray) => {
            if(fontInArray.value === value){
                return fontInArray
            }
        });
        if(selectedFont){
            setFontLabel(selectedFont.label);
        }

    }

    const onUploadLogoFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files![0];

        let imageLoader = new ImageLoader();
        let imageDimentions = await imageLoader.loadImageDimensions(file);
        if (imageDimentions.width > 300 || imageDimentions.height > 200) {
            setInfoPopupSubTitle('Logo must be smaller than 300x200px.')
            setShowInfoPopup(true)
            return;
        }

        const newLogo: FileDto = {
            label: file.name,
            file: file
        };

        setLogo(newLogo);
        setLogoUrl(URL.createObjectURL(file));


        //props.state.uploadLogo = newLogo;

        // props.stateChange();
    }

    const onUploadBackgroundImage = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files![0];

        let imageLoader = new ImageLoader();
        let imageDimentions = await imageLoader.loadImageDimensions(file);
        // if (imageDimentions.width > 300 || imageDimentions.height > 200) {
        //     setInfoPopupSubTitle('Logo must be smaller than 300x200px.')
        //     setShowInfoPopup(true)
        //     return;
        // }

        const newBackground: FileDto = {
            label: file.name,
            file: file
        };

        setBackgroundImg(newBackground);
        setBackgroundUrl(URL.createObjectURL(file));
        setImageUrlMain(true);


        //props.state.uploadLogo = newLogo;

        // props.stateChange();
    }

    const handleSave = () => {
        const data = {
            ...props.dto,
            gusCaption: themeName,
            gusPrimaryColorRgb: color,
            gusLogo: logo?.label!,
            gusLogoUrl: logoUrl ? logoUrl! : '',
            gusFont: fontName,
            gusBackgroundColorRgb: !isImageUrlSelected ? backgroundColor : ``,
            gusBackgroundImage: isImageUrlSelected ? backgroundImg?.label : ``,
            gusBackgroundImageUrl: isImageUrlSelected && backgroundUrl ? backgroundUrl : '',
            gusIconContrast: iconStyle.iconStyleType
        }
        // props.dto.gusCaption = themeName;
        // props.dto.gusPrimaryColorRgb = color;
        // props.dto.gusLogo = logo?.label!;
        // props.dto.gusLogoUrl = logoUrl ? logoUrl! : '';
        // props.dto.gusFont = fontName;
        // props.dto.gusBackgroundColorRgb = !isImageUrlSelected ? backgroundColor : ``;
        // props.dto.gusBackgroundImage = isImageUrlSelected ? backgroundImg?.label : ``;
        // props.dto.gusBackgroundImageUrl = isImageUrlSelected && backgroundUrl ? backgroundUrl : '';
        props.onSave(data, backgroundImg ? backgroundImg : null, logo ? logo! : null);
    }

    useEffect(() => {
        setThemeName(props.dto?.gusCaption ? props.dto.gusCaption! : '')
        setColor(props.dto?.gusPrimaryColorRgb ? props.dto.gusPrimaryColorRgb! : '#0000FF')
        setBackgroundColor(props.dto?.gusBackgroundColorRgb ? props.dto.gusBackgroundColorRgb! : '#ffffff')
        var fileDto: FileDto = {
            file: null,
            label: props.dto?.gusLogo ? props.dto.gusLogo! : null
        }
        setLogo(fileDto)

        const backgroundDto: FileDto = {
            file: null,
            label: props.dto.gusBackgroundImage ? props.dto.gusBackgroundImage : null
        }
        setBackgroundImg(backgroundDto);
        setIconStyle(getIconStyle(props.dto.gusIconContrast || 1));
        setLogoUrl(props.dto?.gusLogoUrl ? props.dto.gusLogoUrl! : '');
        setBackgroundUrl(props.dto.gusBackgroundImageUrl ? props.dto.gusBackgroundImageUrl : ``);
        setImageUrlMain(!Boolean(props.dto.gusBackgroundColorRgb) && Boolean(props.dto.gusBackgroundImageUrl));

        setFontName(props.dto?.gusFont ? props.dto?.gusFont : FONT_NAME_ROBOTO);
        if (props.dto?.gusFont === 'OpenSans') {
            setFontLabel('Open Sans')
        } else if (props.dto?.gusFont === 'AlmoniTzar') {
            setFontLabel('Almoni Tzar (Hebrew)')
        } else if (props.dto?.gusFont === 'OpenSansHeb') {
            setFontLabel('Open Sans (Hebrew)')
        } else {
            setFontLabel(props.dto?.gusFont ? props.dto?.gusFont : FONT_NAME_ROBOTO);
        }

    }, [props.dto])

    useEffect(() => {
        if (props.show && dragManager.current && contentRef.current && headerRef.current) {
            dragManager.current.init(contentRef.current!, headerRef.current!)
        }

        return () => {
            if (dragManager.current) {
                dragManager.current.dispose();
            }
        }

    }, [props.show, contentRef.current, headerRef.current])

    if (!props.show) {
        return null
    }

    const setting = {
        modalName: "error"
    }

    return (
        <>
            <div ref={contentRef} className="gui_theme_settings">

                <div className="gui_theme_settings_content">

                    <GuiThemesHeader ref={headerRef} label="Brand Settings" onClose={props.onHide}/>

                    <div className="container">

                        <div className="gui_theme_container">
                            <TextInput
                                label="Brand:"
                                type="text"
                                value={themeName}
                                onChange={e => {
                                    var value = e.target.value;
                                    setThemeName(value)
                                }}
                                errorMessage={''}
                                verticalMode={false}
                                horizontalLabelCol="col-sm-3"
                                horizontalInputCol="col-sm-9"
                                maxLength={30}
                                bordersColor={"#d1d7db"}
                                withoutErrorMessage={true}
                            />
                        </div>

                        <div className="row">
                            <div className="col-sm-3" style={{
                                display: `flex`,
                                alignItems: `center`
                            }}>
                                <label>Brand Color:</label>
                            </div>
                            <div className="col-sm-9">
                                <ColorsSelector
                                    currentSelectedColor={color}
                                    onColorSwatchChange={onColorSwatchChange}
                                    type={`color`}
                                    backgroundImageURL={backgroundUrl}
                                    isImageUrlSelected={isImageUrlSelected}
                                />
                            </div>
                        </div>

                        <div className="upload_logo_container row">
                            <div className="col-sm-3" style={{
                                display: `flex`,
                                alignItems: `center`
                            }}>
                                <label htmlFor="" style={{
                                    margin: 0
                                }}>
                                    Upload Logo:
                                </label>
                            </div>
                            <div className="col-sm-9">
                                <Grid container sx={{height: `100%`}} alignItems={`center`} columnSpacing={1}>
                                    {
                                        !logo?.label &&
                                        <Grid item xs>
                                            <Box sx={{
                                                display: `flex`,
                                                alignItems: `center`
                                            }}>
                                                <Box sx={{
                                                    maxWidth: `50px`,
                                                    maxHeight: `50px`,
                                                    minWidth: `50px`,
                                                    minHeight: `50px`,
                                                    border: `1px solid #d1d7db`,
                                                    borderRadius: `5px`,
                                                    display: `flex`,
                                                    alignItems: `center`
                                                }}>
                                                    <ImageWithError style={{
                                                        maxWidth: `inherit`,
                                                        maxHeight: `inherit`,
                                                        width: `100%`,
                                                        height: `100%`,
                                                        padding: `2px`,
                                                    }}/>
                                                </Box>
                                                <Typography fontSize={`12px`} mx={`20px`}>
                                                    No Image
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    }
                                    {
                                        logoUrl &&
                                        <Grid item xs>
                                            <Box sx={{
                                                display: `flex`,
                                                justifyContent: `center`,
                                                padding: `10px 10px`,
                                                backgroundColor: color
                                            }}>
                                                <img src={logoUrl} alt="img" style={{
                                                    maxWidth: `100%`,
                                                    maxHeight: `50px`
                                                }}/>
                                            </Box>

                                        </Grid>
                                    }
                                    <Grid item xs={2}>
                                        <Box sx={{
                                            display: `flex`, alignItems: `center`,
                                            justifyContent: `center`,
                                        }}
                                             title={`Upload Image`}
                                        >
                                            <LabelFileSelector
                                                accept={".png, .jpg"}
                                                fileId="upload_logo"
                                                onChange={onUploadLogoFileChange}
                                            >
                                                <UploadIcon/>
                                            </LabelFileSelector>

                                        </Box>
                                    </Grid>
                                </Grid>
                                {/*<div className="row">*/}

                                {/*    <div className="col-sm-3">*/}
                                {/*        <p>{logo?.label ? logo?.label : '--'}</p>*/}
                                {/*    </div>*/}

                                {/*    <div className="col-sm-6 logo_image_container">*/}
                                {/*        {logoUrl && <img src={logoUrl} alt="img"/>}*/}
                                {/*    </div>*/}
                                {/*    <div className='col-sm-3'>*/}
                                {/*        test*/}
                                {/*    </div>*/}

                                {/*</div>*/}

                            </div>
                        </div>

                        <div className="row flyer_languages_container">
                            <div className="col-sm-3">
                                <label>Font:</label>
                            </div>
                            <div className="col-sm-9 dropdown">
                                <FontsSelect
                                    fontName={{value: fontName, label: fontLabel}}
                                    onChange={onFontSelectorChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3" style={{
                                display: `flex`,
                                alignItems: `center`
                            }}>
                                <label>Icon Style:</label>
                            </div>
                            <div className="col-sm-9">
                                <IconsStylesDropdown
                                    iconStyle={iconStyle}
                                    setIconStyle={setIconStyle}
                                    mainColor={color}
                                />
                                {/*<IconsStyleSelector*/}
                                {/*    iconStyle={iconStyle}*/}
                                {/*    setIconStyle={setIconStyle}*/}
                                {/*    mainColor={color}*/}
                                {/*/>*/}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3" style={{
                                display: `flex`,
                                alignItems: `center`
                            }}>
                                <label>Background:</label>
                            </div>
                            <div className="col-sm-9">
                                <ColorsSelector
                                    currentSelectedColor={backgroundColor}
                                    onColorSwatchChange={onBackgroundSwatchChange}
                                    type={`backgroundColor`}
                                    backgroundImageURL={backgroundUrl}
                                    isImageUrlSelected={isImageUrlSelected}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                            </div>
                            <div className="col-sm-9">
                                <Grid container columnSpacing={1}>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs>
                                        <Grid container sx={{height: `100%`}} alignItems={`center`}
                                              columnSpacing={`2px`}>
                                            <Grid item xs>
                                                <Box sx={{
                                                    display: `flex`
                                                }}>
                                                    <Box sx={{
                                                        maxWidth: `50px`,
                                                        maxHeight: `50px`,
                                                        minWidth: `50px`,
                                                        minHeight: `50px`,
                                                        border: `1px solid #d1d7db`,
                                                        borderRadius: `5px`
                                                    }}>
                                                        <AsyncImageWithLoader
                                                            src={backgroundUrl && isImageUrlSelected ? backgroundUrl : ``}
                                                            notUploadIcon={(
                                                                <ImageWithError/>
                                                            )}
                                                        />
                                                    </Box>
                                                    <Box sx={{display: `flex`, alignItems: `center`, margin: `0 20px`}}>
                                                        {backgroundImg?.label && isImageUrlSelected
                                                            ? <Typography>
                                                                {backgroundImg.label}
                                                            </Typography>
                                                            : <Typography fontSize={`12px`}>No Image</Typography>

                                                        }
                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Box
                                                    sx={{
                                                        display: `flex`, alignItems: `center`,
                                                        justifyContent: `center`,
                                                    }}
                                                    title={`Upload Image`}
                                                >
                                                    <LabelFileSelector
                                                        accept={".png, .jpg"}
                                                        fileId="upload_background"
                                                        onChange={onUploadBackgroundImage}
                                                    >
                                                        <UploadIcon/>
                                                    </LabelFileSelector>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>

                        <div className="save_button_container row">
                            <div className="col-sm-4">

                            </div>
                            <div className="col-sm-8">
                                <div className="save_button" onClick={handleSave}>Save</div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <StatusPopup
                settings={setting}
                type={StatusPopupType.INFO}
                title={'INFO'}
                subTitle={infoPopupSubTitle}
                messages={[]}
                show={showInfoPopup}
                handleClose={() => setShowInfoPopup(false)}
            />

        </>

    )
}

export default GuiThemeSettingsPopup